import script from "./TableQuery.vue?vue&type=script&setup=true&lang=js"
export * from "./TableQuery.vue?vue&type=script&setup=true&lang=js"

import "./TableQuery.vue?vue&type=style&index=0&id=9c4c22de&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9c4c22de"]])

export default __exports__